import { TOOLTIP_DELAY_MS, TooltipProvider } from "@/components/ui/tooltip";
import { VersionUpdateBanner } from "@/components/version-update-banner";
import { queryClient } from "@/lib/query-client";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { useAuthStore } from "./features/auth/store";
import { routeTree } from "./routeTree.gen";

const router = createRouter({ routeTree });

if (import.meta.env.DEV) {
  (window as unknown as { __authSeed?: () => void }).__authSeed = () => {
    useAuthStore.getState().setUser({
      id: "dev",
      email: "dev@localhost",
      username: "e2e",
      role: "admin",
      user_status: "active",
      profile_image_url: null,
      is_ops_staff: true,
    });
  };
}
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      {/* IR-1247: Radix `Tooltip` throws if no `TooltipProvider` is above it,
          which error-boundaries the whole page. Provide one at the root so a
          tooltip anywhere in the tree can never take a tab down again. */}
      <TooltipProvider delayDuration={TOOLTIP_DELAY_MS}>
        <RouterProvider router={router} />
        {/* IR-1412 r2: shell-level so every page picks up new deploys — an
            open tab otherwise runs the stale bundle forever. */}
        <VersionUpdateBanner />
      </TooltipProvider>
    </QueryClientProvider>
  );
}
